module.exports = __webpack_public_path__ + "static/media/payment-bank-transfer.bc1fd751.png";